import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import ContentLoader from 'react-content-loader'

import { store } from '../../../index'

import states from '../../../lib/states'

const Main = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: rgba(192, 192, 192, 0.3);
  border-radius: 10px;
  display: flex;
`

const ProgressLine = styled.div`
  position: relative;
  height: ${props => props.height};
  background-image: linear-gradient(92deg, #00fff2, #00b4fe);
  animation: ${drawProgressLine} ${props => props.duration} linear;
  border-radius: 10px;
`

function drawProgressLine(props) {
  return keyframes`
    from {
      width: ${props.from};
    }
    to {
      width: ${props.width};
    }
  `
}

export class ProgressBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      resetAnimation: false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.song && prevProps.song && this.props.song.id !== prevProps.song.id) {
      this.setState({
        resetAnimation: true
      })
    } else if (this.state.resetAnimation === true){
      this.setState({
        resetAnimation: false
      })
    }
  }

  render() {
    const initialPosition = store.getState().position / store.getState().duration * this.props.width
    const duration = this.props.song ? this.props.song.duration - this.props.song.position : 0
    const contentLoaderStyle = {
      position: 'absolute',
      height: `${this.props.height}px`
    }
    return (
      <Main width={`${this.props.width}px`} height={`${this.props.height}px`}>
        {((status) => {
          switch(status) {
          case states.AUTOSYNC:
          case states.BUFFERING:
          case states.PAUSED:
            if (this.props.width > 0) {
              return (
                <ContentLoader height={this.props.height} width={this.props.width} speed={3} style={contentLoaderStyle}/>
              )
            } else {
              return null
            }

          case states.PLAYING:
            if (this.state.resetAnimation === true) {
              return null
            }
            return (
              <ProgressLine height={`${this.props.height}px`} width={`${this.props.width}px`} from={`${initialPosition}px`} duration={`${duration}s`} />
            )

          default:
            return null
          }
        })(this.props.status)}
      </Main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/player/utils/progressBar.js